/*
	*数据脱敏*
	*@param {object} e 
	*@param {object} start 保留前面几个字符串
	*@param {object} end 保留后面几个字符串
 */
/*
	*银行卡脱敏 并分割字符串*
*/
function cardDesensitization(str, begin, end) {
	if (!str && (begin + end) >= str.length) {
		return "";
	}
	let leftStr = str.substring(0, begin);
	let rightStr = str.substring(str.length - end, str.length);

	let strCon = ''
	for (let i = 0; i < str.length - end - begin; i++) {
		strCon += '*';
	}
	// return leftStr + strCon + rightStr;
	let card = leftStr + strCon + rightStr
	const NEWCARD = card.substr(0,4) + ' **** **** **** ' + card.substr(card.length - 3)
	return NEWCARD
}
/**
 * @description 手机号脱敏，隐藏手机号中间4位数
 * @param {*} mobile 
 * @returns mobile 
 */
function mobileDesensitization(mobile) {
	if(mobile !== null && mobile !== undefined) {
		return mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")
	} else {
		return mobile
	}
}
/**
 * @description 昵称信息脱敏
 * @param {Object} str
 * @returns 保留第一位
 */
function nickDesensitization(str) {
	if(str !== null && str !== undefined) {
		if(str !== ''){
			return str.substr(0,1) + '*'
		} else {
			return str
		}
	} else {
		return str
	}
}
/**
 * 身份证号脱敏
 * @param {Object} str
 */
function idcardDesensitization(str){
	return str.replace(/^(.{3})(?:\d+)(.{4})$/,"$1***********$2")
}
/**
 * 详细地址脱敏
 * @param {Object} str
 */
function addressDesensitization(str){
	if(str !== null && str !== undefined) {
		if(str !== ''){
			return '*******'
		} else {
			return str
		}
	} else {
		return str
	}
}

export default {
	cardDesensitization,
	mobileDesensitization,
	nickDesensitization,
	idcardDesensitization,
	addressDesensitization
}


// WEBPACK FOOTER //
// ./src/common/filters.js